import React from 'react'
import { ActivityIndicator } from 'react-native-paper'
import { StyleSheet, View, ViewStyle } from 'react-native'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'

const styles = StyleSheet.create({
  wrapper: {
    ...StyleSheet.absoluteFillObject,
    alignItems: 'center',
    justifyContent: 'center',
  },
})

interface LoadingProps {
  children?: React.ReactElement
  style?: ViewStyle
}

export default function Loading({ style, children }: LoadingProps) {
  return (
    <View style={composeStyle(styles.wrapper, style)}>
      <ActivityIndicator testID="indicator" />
      {children}
    </View>
  )
}
